export const passwordValidation = (password) => {
  var regularExpression =
    /^(?=.*[0-9])(?=.*[!@#$%^&*])[a-zA-Z0-9!@#$%^&*]{6,16}$/;
  return regularExpression.test(password);
};

export const validateEmail = (email) => {
  return String(email)
    .toLowerCase()
    .match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-z\-0-9]+\.)+[a-z ]{2,}))$/
    );
};
export const isValidPassword = (password) => {
  const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()\-_=+{};:,<.>ยง~])(?=.{8,64})/;
  return regex.test(password);
};
export const isValidEmail = (email) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};
export const specialCharacterValidation = (value) => {
  return /^[0-9a-zA-Z ]+$/.test(value);
};


export const accessUrlValidation = (value) => {
  return /^[0-9a-zA-Z\-\b ]+$/.test(value);
};

export const validateUserName = (userName) => {
  if (!userName) {
    return false;
  }

  if (userName.includes("@")) {
    const emailRegex = /^[a-zA-Z0-9_\-+.]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailRegex.test(userName);
  } else {
    const usernameRegex = /^[a-zA-Z0-9_\-+\.]+$/;
    return usernameRegex.test(userName);
  }
};

// export const validateAwsAccountNumber = (accountNumber) => {
//   if (!accountNumber) {
//     return false;
//   }
//   return /^[0-9]+$/.test(accountNumber) && accountNumber.length == 12;
// };
export const validateAwsAccountNumber = (accountNumber) => {
  const invalidFormatMessage = "AWS Account Number must be a 12-digit number";

  if (!accountNumber) {
    return { isValid: false, message: invalidFormatMessage };
  }

  const isValid = /^[0-9]{12}$/.test(accountNumber);
  return {
    isValid,
    message: isValid ? "" : invalidFormatMessage,
  };
};

export const validateInstanceId = (instanceId) => {
  const invalidFormatMessage = "Instance ID must be a valid InstanceId";

  if (!instanceId) {
    return { isValid: false, message: invalidFormatMessage };
  }

  // UUID v4 pattern: 8-4-4-4-12 hex digits
  const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

  const isValid = uuidRegex.test(instanceId);
  return {
    isValid,
    message: isValid ? "" : invalidFormatMessage,
  };
};


export const validateAllowChatDomainURL = (domianURL) => {
  return /^(https?:\/\/)?(www\.)?([a-zA-Z0-9-]{1,63}\.)+(com|in|info|net|org|co|digital|biz|online)$/.test(domianURL);

}
export const validatePhoneNumber = (phoneNumber) => {
  if (!phoneNumber) {
    return false;
  }
  
  // Validate phone number (exactly 10 digits)
  const phoneRegex = /^\d{10}$/;
  return phoneRegex.test(phoneNumber);
};

export const validateRoleArn = (roleArn) => {
  const arnRegex = /^arn:aws:iam::\d{12}:role\/[a-zA-Z_0-9+=,.@\-_/]+$/;
  // const invalidFormatMessage = "Invalid Role ARN format";

  if (!roleArn || !arnRegex.test(roleArn)) {
    return { isValid: false };
  } else {
    const parts = roleArn.split(':');
    if (
      parts.length < 6 ||
      parts[0] !== "arn" ||
      parts[1] !== "aws" ||
      parts[2] !== "iam" ||
      parts[3] !== "" ||
      !/^\d{12}$/.test(parts[4]) ||
      !parts[5].startsWith("role/")
    ) {
      // return { isValid: false, message: invalidFormatMessage };
      return { isValid: false };

    } else {
      return { isValid: true};
    }
  }
};

export const handleEnterKey = (e, nextRef) => {
  if (e.key === "Enter") {
    e.preventDefault();
    if (nextRef?.current) {
      nextRef.current.focus();
    }
  }
};

export const removeRSpacefromString = (string) => {
  if (!string) {
    return { isValid: false, value: "", message: "Input is required" };
  }

  const trimmed = string.replace(/\s+$/g, "");

  return {
    isValid: trimmed.length > 0,
    value: trimmed,
    message: trimmed.length > 0 ? "" : "Please enter a valid input",
  };
};

export const removeLSpaceFromString = (string) => {
  if (!string) {
    return { isValid: false, value: "", message: "Input is required" };
  }
  
  const trimmed = string.replace(/^\s+/g, "");
  return {
    isValid: trimmed.length > 0,
    value: trimmed,
    message: trimmed.length > 0 ? "" : "Please enter a valid input",
  };
};
export const validateClientId = (clientId) => {
  const invalidFormatMessage =
    "Please enter valid Client Id";

  if (!clientId) {
    return { isValid: false, message: invalidFormatMessage };
  }

  // UUID v4 regex pattern
  const isValid = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(clientId);

  return {
    isValid,
    message: isValid ? "" : invalidFormatMessage,
  };
};

export const validateClientSecret = (clientSecret) => {
  const invalidFormatMessage = "Please enter a valid Client Secret";

  if (!clientSecret) {
    return { isValid: false, value: "", message: invalidFormatMessage };
  }

  const isValid = /^[A-Za-z0-9]{20,80}$/.test(clientSecret);

  return {
    isValid,
    value: clientSecret,
    message: isValid ? "" : invalidFormatMessage,
  };
};


export const removeSpaceInBetween = (string = "") => {
  if (!string) {
    return { isValid: false, value: "", message: "Input is required" };
  }

  // Trim leading and trailing spaces
  const trimmed = string.trim();

  // Check for internal spaces
  const hasInternalSpaces = /\s/.test(trimmed);

  if (hasInternalSpaces) {
    return {
      isValid: false,
      value: trimmed,
      message: "Input cannot contain spaces in between",
    };
  }

  return {
    isValid: true,
    value: trimmed,
    message: "",
  };
};


  